import { PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { DatePickerType } from '@/constants/datePicker';
import { DEFAULT_PAGE_SIZE } from '@/constants/pagination';
import { CountMap } from '@/constants/usage';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type UsageSearchQuery = {
  id: string;
  datePickerType: DatePickerType;
  start?: string;
  end?: string;
  companyName?: string;
  svcName?: string;
  settleId?: string;
  appId?: string;
  /** 모바일전자증명은 앱 ID 대신 Platform ID로 조회한다 */
  platformId?: string;
  productIds?: string[];
  chargedOnly?: boolean;
  page: number;
};

/** 모바일전자증명은 과금이 발생한 내역만 조회한다. 그 외 BIZ는 파라미터를 보내지 않는다. */
export const getChargedOnly = (bizType: BizType | null) => (bizType === BizType.EPROOF ? true : undefined);

export type UsageStat = {
  count: number;
  usageAmount?: number;
};

export type UsageData = {
  appId?: string; // MYDATA 타입은 없음
  platformId?: string;
  companyName: string;
  useMap: Partial<Record<CountMap, UsageStat>>;
  date: string;
  productCode: string;
  settleId: string;
  svcName: string;
};

export const getStatSearch = (params: UsageSearchQuery) => {
  return api<PaginationPcApiResponse<UsageData[]>>('get', `/pc-api/v1/${PREFIX_PATH}/stat/search`, {
    ...params,
    size: DEFAULT_PAGE_SIZE
  });
};
